import { render, staticRenderFns } from "./GamifyOverlay.vue?vue&type=template&id=8bde8160&scoped=true&"
import script from "./GamifyOverlay.vue?vue&type=script&lang=js&"
export * from "./GamifyOverlay.vue?vue&type=script&lang=js&"
import style0 from "./GamifyOverlay.vue?vue&type=style&index=0&id=8bde8160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bde8160",
  null
  
)

export default component.exports